import {
  faBook,
  faCircleUser,
  faFileAlt,
  faFlask,
  faSignOut,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Session } from '@feathr/blackbox';
import { Menu, MenuItem, toast } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import styles from './UserNav.css';

function UserNav(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const isDevEnvironment = SHRIKE_ENV !== 'production';

  async function handleLogOut(): Promise<void> {
    try {
      await Session.logOut(() => {
        window.location.assign(
          `${Session.logInUrl}?from=${encodeURIComponent(window.location.href)}`,
        );
      });
    } catch (error) {
      toast(t("Couldn't log out. Try again."), {
        type: 'error',
      });
    }
  }

  return (
    <Menu className={styles.root}>
      <MenuItem
        link={localUrl('/settings/user/profile')}
        prefix={<FontAwesomeIcon icon={faCircleUser} />}
      >
        {t('Profile')}
      </MenuItem>
      {isDevEnvironment && (
        <MenuItem link={localUrl('/ia-prototype')} prefix={<FontAwesomeIcon icon={faFlask} />}>
          {t('IA Overhaul Prototype')}
        </MenuItem>
      )}
      <MenuItem
        href={'https://www.feathr.co/privacy-policy'}
        prefix={<FontAwesomeIcon icon={faFileAlt} />}
        target={'_blank'}
      >
        {t('Privacy Policy')}
      </MenuItem>
      <MenuItem
        href={'https://www.feathr.co/terms'}
        prefix={<FontAwesomeIcon icon={faBook} />}
        target={'_blank'}
      >
        {t('Terms & Conditions')}
      </MenuItem>
      <MenuItem onClick={handleLogOut} prefix={<FontAwesomeIcon icon={faSignOut} />}>
        {t('Log out')}
      </MenuItem>
    </Menu>
  );
}

export default observer(UserNav);
